import { Tag } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArchive, faFire, faToolbox } from '@fortawesome/pro-solid-svg-icons'
import { ProjectType, ProjectTypes, projectTypeName } from '../../common/constants'

const icons = {
  [ProjectTypes.Project]: faArchive,
  [ProjectTypes.Ticket]: faFire,
  [ProjectTypes.Maintenance]: faToolbox
} as Record<number, typeof faArchive>

const JobTypeTag = ({ type }: { type: number }) => (
  <Tag><FontAwesomeIcon icon={icons[type]} /> &nbsp;{projectTypeName(type as ProjectType)}</Tag>
)

export default JobTypeTag
